import { deleteMed, updateMed, medsState, updateMedsState, setMedsLoading, getCurrentUserId, getCurrentUserRegistrationId, setDemoMode, getUsersList, deleteMedsHistory, prescriptionsState, setPrescriptionsLoading, updatePrescriptionsState, } from 'store/storeValtio';
import { deleteHistByMedId, addMedsHistory, medsHistoryState, updateMedsHistoryState, setMedsHistoryLoading, } from 'store/storeValtio'; 
import { conditionsState, updateConditionsState, setConditionsLoading, } from 'store/storeValtio';
import { ingredientsState, updateIngredientsState, setIngredientsLoading, } from 'store/storeValtio';
import { supplementsState, updateSupplementsState, setSupplementsLoading, } from 'store/storeValtio';
import { usersListState, updateUserState, setUserStateLoaded } from 'store/storeValtio';
import { updateUsersListState } from 'store/storeValtio';
import { getAll, getData, getIndexedData, getAllData, getSelectedData, deleteData, deleteIndexedData, deleteIndexedDataByIndex, getDataRange, deleteAllData } from './idb';
import { insertValues, updateData } from './idb';
import { generateUniqueId, getNowISO, sleep } from 'helpers/generalHelpers';

export async function addUserToDb(user) {
  user.dateCreated = getNowISO();
  user.dateUpdated = getNowISO();
  //console.log('addUserToDb: ', user);
  let response = await insertValues('users', user);
  let result = await response;
  //console.log('addUserToDb result', result);
  addTransactionToDb('users', 'add', user);
  return result;
}

export async function getUsersFromDb() {
    console.log('getUsersFromDb');
    if (!usersListState || usersListState.loaded) {
      //console.log('users already loaded or being loaded');
      return;
    }
    var wait = true;

    var dbUsersPromise = getAll('users')
    dbUsersPromise
      .then(result => {
        var dbUsers = result;
        console.log('dbUsers', dbUsers);
        const users = [];
        dbUsers.forEach((u) => {
          var data = u;
          //console.log(data)
          users.push(data);
        });
        const newList = {
          loaded: true,
          usersList: users
        }
        updateUsersListState(newList);
        console.log('getUsersFromDb', dbUsers, newList, getUsersList());
        wait = false;
      })
      .catch(err => {
        console.log('getUsersFromDb error', err);
        updateUsersListState({ loaded: false, usersList: [] });
        alert(err.message);
      })

    while (wait) {
      await sleep(500) 
    }

    return;
}

export async function getUserFromDb(key) {
  //console.log('getUserFromDb', key);
  setUserStateLoaded(false);
  try {
    let response = await getData('users', key)
    const user = await response;
    //console.log('getUserFromDb result', user);
    const dbUser = {
      loaded: true,
      authenticated: true,
      currentUser: user,
      currentUserId: user.userId
    };
    console.log('getUserFrom Db', dbUser);
    updateUserState(dbUser);
    return user;
  } catch (err) {
    console.log('getUserFromDb error', key, err);
    return null;
  };
}

export async function updateUserInDb(profile) {
  profile.dateUpdated = getNowISO();
  //console.log('updateProfile', profile);
  updateData('users', profile)
    .then((result)=>{
      //console.log('updateUserInDb', result);
      addTransactionToDb('users', 'update', profile);
    })
    .catch((error)=>{
      console.log('updateUserInDb error', error);
      throw error;
    });
}

export async function getMedicationsFromDb() {
  //console.log('getMedicaitonsFromDb');
  if (!medsState || medsState.loaded || medsState.loading) {
    //console.log('meds already loaded or being loaded');
    return;
  }
  const userId = getCurrentUserId();
  console.log("getMeds: ", userId);
  setMedsLoading(true);
  try {
    //var meds = await getAllData('medications');
    var meds = await getSelectedData(
      'medications',
      'userId',
      userId
    );
    const medsUpdate = [];
    meds.forEach((m) => {
      if (m.dateUpdated instanceof Date) m.dateUpdated = m.dateUpdated.toISOString();
      medsUpdate.push(m);
      //console.log(m)
    });
    updateMedsState({ loaded: true, loading: false, meds: medsUpdate });

    //console.log('snap updateMedsState', medsUpdate, medsState.meds);
  } catch (err) {
    console.log('loadMeds error', err);
    //alert(err.message);
  } finally {
  }
}

export async function getMedsHistoryFromDb() {
  //console.log('getMedsHistoryFromDb');
  if (
    !medsHistoryState ||
    medsHistoryState.loaded ||
    medsHistoryState.loading
  ) {
    //console.log('hist already loaded or being loaded');
    return;
  }

  setMedsHistoryLoading(true);
  try {
    var hist = await getSelectedData(
      'history',
      'userId',
      getCurrentUserId()
    );
    // make copy of data
    const medsHistoryUpdate = [];
    hist.forEach((h) => {
      var data = h;
      if (data.date instanceof Date) data.date = data.date.toISOString();
      if (data.dateUpdated instanceof Date) data.dateUpdated = data.dateUpdated.toISOString();
      //console.log(data)
      medsHistoryUpdate.push(data);
      //console.log("DB hist: ", data);
    });
    //console.log('before sort', medsHistoryUpdate);
    medsHistoryUpdate.sort((a, b) => {
      if (a.date < b.date) {
        return 1;
      }
      if (a.date > b.date) {
        return -1;
      }
      return 0;
    });
    //console.log('after sort', medsHistoryUpdate);

    updateMedsHistoryState({
      loaded: true,
      loading: false,
      medsHistory: medsHistoryUpdate,
    });
    //console.log('updateHistState', medsHistoryState, medsHistoryState.medsHistory);
  } catch (err) {
    console.log('loadHist error', err);
    //alert(err.message);
  } finally {
  }
}

export async function addMedicationToDb(med) {
  med.medicationId = generateUniqueId();
  med.dateUpdated = getNowISO();
  //console.log('addMedicationToDb', med);
  await insertValues('medications', med)
    .then ((result)=>{
      //console.log('addMedicationToDb result', result);
      addTransactionToDb('medications', 'add', med);
    })
    .catch ((error)=>{
      console.log('addMed error', error);
    });
}

export async function updateMedicationInDb(med) {
  if (!med) return;

  const newMed = {
    medicationId: med.medicationId,
    userId: med.userId,
    labelId: med.labelId,
    name: med.name,
    type: med.type,
    brand: med.brand,
    orangeId: med.orangeId,
    description: med.description,
    form: med.form,
    dosage: med.dosage,
    strength: med.strength,
    occurance: med.occurance,
    often: med.often,
    schedule: JSON.parse(JSON.stringify(med.schedule)),
    isPaused: med.isPaused,
    withMeals: med.withMeals,
    sortOrder: med.sortOrder,
  };

  newMed.dateUpdated = getNowISO();
  //console.log('updateMedicationInDb', newMed);
  updateData('medications', newMed)
    .then((result)=>{
      //console.log('updateMedicationInDb done');
      updateMed(newMed);
      addTransactionToDb('medications', 'update', newMed);
    })
    .catch((error)=>{
      console.log('updateMedicationInDb error', error);
    });
}

export async function updateMedSortOrderInDb(med, sortOrder) {
  //console.log('updateMedSortOrder', med, sortOrder);
  med.sortOrder = sortOrder;
  med.dateUpdated = getNowISO();
  updateData('medications', med)
    .then((result)=>{
      addTransactionToDb('medications', 'update', med);
    })
    .catch((error)=>{
      console.log('updateMedSortOrderInDb error', error);
    })
}

export async function deleteMedicationInDb(medId) {
  //console.log('deleteMedication', medId);
  if (!medId) return;
  // delete the history first just in case it fails
  deleteIndexedDataByIndex('history', 'medicationId', medId)
    .then(()=>{
      deleteIndexedData('medications', medId)
      .then(()=>{
        deleteMed(medId);
        deleteHistByMedId(medId);
        const med = {
          userId: getCurrentUserId(),
          medicationId: medId
        }
        addTransactionToDb('medications', 'deleteMed', med )
      })
      .catch((error)=>{
        console.log('deleteMedicationInDb DeleteHist Error', error);
      })
    })
    .catch((error)=>{
      console.log('deleteMedicationInDb', error);
      throw error;
    });
}

export async function addHistoryToDb(hist) {
  if (!hist) return;
  //console.log('addHist', hist);
  hist.historyId = generateUniqueId();
  hist.dateUpdated = getNowISO();
  await insertValues( 'history', hist)
    .then((result)=>{
      //console.log('addHistoryToDb', result);
      addMedsHistory(hist);
      addTransactionToDb('history', 'add', hist);
    })
    .catch((error)=>{
      console.log('addHistoryToDb error', error);
    });
}
export async function deleteMedicationHistoryInDb(userId, medId) {
  //console.log('deleteMedicationHistoryInDb', histId);
  if (!medId) return;
  await deleteIndexedDataByIndex('history', 'medicationId', medId)
    .then((result)=>{
      console.log('deleteMedicationHistoryInDb result', result);
      // clear the store
      deleteHistByMedId(getCurrentUserId(), medId);

      const medHistDel = {
        userId: userId,
        medId: medId
      }
      addTransactionToDb('medhistory', 'delete', medHistDel);
    })
  .catch((error)=>{
    console.log('deleteMedicationHistoryInDb error', error);
    throw error;
  });
}

export async function deleteHistoryInDb(userId, histId) {
  //console.log('deleteHistoryInDb', histId);
  if (!histId) return;
  await deleteIndexedData('history', histId)
    .then((result)=>{
      //console.log('deleteHistoryInDb result', result);
      const histDel = {
        userId: userId,
        historyId: histId
      }
      addTransactionToDb('history', 'delete', histDel);
    })
  .catch((error)=>{
    console.log('deleteHistoryInDb error', error);
    throw error;
  });
}

export async function deleteHistoryLocal(userId, histId) {
  //console.log('deleteHistoryLocal', histId);
  if (!histId) return;
  await deleteIndexedData('history', histId)
    .then((result)=>{
      deleteMedsHistory(histId)
    })
  .catch((error)=>{
    console.log('deleteHistoryLocal error', error);
    throw error;
  });
}
// conditions 

export async function addConditionToDb(cond) {
  //console.log('addCond', cond);
  cond.conditionId = generateUniqueId();
  cond.dateUpdated = getNowISO();
  await insertValues('conditions', cond)
    .then((result)=>{
      //console.log('addConditionToDb', result);
      addTransactionToDb('conditions', 'add', cond);
    })
    .catch((error)=>{
      console.log('addConditionToDb error', error);
    });
}

export async function getConditionsFromDb() {
  //console.log('getConditionsFromDb');
  if (!conditionsState || conditionsState.loaded || conditionsState.loading) {
    //console.log('conditons already loaded or being loaded');
    return;
  }

  setConditionsLoading(true);
  try {
    var cond = await getSelectedData(
      'conditions',
      'userId',
      getCurrentUserId()
    );
    //var cond = await getAllData("conditions");
    const conditionsUpdate = [];
    //console.log('fs loadHist new data',querySnapshot);
    cond.forEach((c) => {
      const data = c;
      //console.log(data)
      data.date = getNowISO();
      conditionsUpdate.push(data);
      //console.log(data, cond)
    });
    updateConditionsState({
      loaded: true,
      loading: false,
      conditions: conditionsUpdate,
    });
    //console.log('updateConditionsState', conditionsState, conditionsState.conditions);
  } catch (err) {
    console.log('loadCond error', err);
    //alert(err.message);
  } finally {
  }
}

export async function addArchiveToDb(uid, hist) {
  if (!hist) return;
  //console.log('addArchive', hist);
  try {
    //console.log('aatf', result);
  } catch (error) {
    console.log('addArchiveToDb', error);
  }
}

// Ingredients

export async function getIngredientsFromDb() {
  //console.log('getIngredientsFromDb');
  if (!ingredientsState || ingredientsState.loaded || ingredientsState.loading) {
    //console.log('ingredients already loaded or being loaded');
    return;
  }

  setIngredientsLoading(true);
  let ingredientsUpdate = [];
  try {
    var ing = await getSelectedData(
      'ingredients',
      'userId',
      getCurrentUserId()
    );
    //var ing = await getAllData("ingredients");
    //console.log('getSelectedData ingredients', ing);
    ing.forEach((i) => {
      const data = i;
      ingredientsUpdate.push(data);
    });
    updateIngredientsState({
      loaded: true,
      loading: false,
      ingredients: ingredientsUpdate,
    });
  } catch (err) {
    console.log('loadIngredients error', err);
  } finally {
  //console.log('loadIngredients done', ingredientsUpdate);
  }
}

export async function addIngredientToDb(item) {
  //console.log('addIngredientToDb', item);
  item.ingredientId = generateUniqueId();
  item.dateUpdated = getNowISO();
  await insertValues('ingredients', item)
    .then ((result) => {
      addTransactionToDb('ingredients', 'add', item);
    })
    .catch((error)=> {
      console.log('addIngredientToDb error', error);
    });
}

export async function deleteIngredientInDb(ingredient) {
  //console.log('deleteIngredientInDb', ingredient);
  if (!ingredient) return;
  deleteIndexedData('ingredients', 'ingredientId', ingredient.ingredientId)
    .then((result)=>{
      const ingDel = {
        userId: ingredient.userId,
        ingredientId: ingredient.ingredientId
      }
      addTransactionToDb('ingredients', 'delete', ingDel);
    })
    .catch((error)=>{
      console.log('deleteIngredientInDb', error);
      throw error;
    });
}

export async function getIngredientFromDb(id) {
  var ing = null;
  getData('ingredients', id)
    .then((result)=>{
      ing = result;
      return ing;
    })
    .catch((err)=>{
      console.log('getIngredientFromDb error', err);
      return null;
    });
}

export async function getIngredientFromDbForMed(indexes, range) {
  let response = await getDataRange('ingredients', indexes, range)
  let ing = await response;
  return ing;
}

export async function updateIngredientInDb(newVals) {
  newVals.dateUpdated = getNowISO();
  //console.log('updateIngredientInDb', newVals);
  let response = await updateData('ingredients', newVals);
  let result = response;
  //console.log('updateIngredient result', result);
  addTransactionToDb('ingredients', 'update', newVals);
}

// Supplements

export async function getSupplementsFromDb() {
  //console.log('getSupplementsFromDb');
  if (!supplementsState || supplementsState.loaded || supplementsState.loading) {
    //console.log('supplements already loaded or being loaded');
    return;
  }

  setSupplementsLoading(true);
  let supplementsUpdate = [];
  try {
    var sup = await getAllData('supplements');
    //var ing = await getAllData("supplements");
    //console.log('getAllData supplements', sup);
    sup.forEach((i) => {
      const data = i;
      supplementsUpdate.push(data);
    });
    updateSupplementsState({
      loaded: true,
      loading: false,
      supplements: supplementsUpdate,
    });
  } catch (err) {
    console.log('loadSupplements error', err);
  } finally {
    //console.log('loadSupplements done', supplementsUpdate);
  }
}

export async function addSupplementToDb(item) {
  //console.log('addSupplement', item);
  item.userId = getCurrentUserId();
  item.supplementId = generateUniqueId();
  item.dateUpdated = getNowISO();
  await insertValues('supplements', item)
    .then((result)=>{
      addTransactionToDb('supplements', 'add', item);
    })
  .catch((error)=>{
    console.log('addSupplementToDb', error);
    return false;
  });
  return true;
}

export async function deleteSupplementInDb(supp) {
  //console.log('deleteSupplementInDb', supp);
  if (!supp) return;
    deleteData('supplements', supp.supplementId)
      .then((result)=>{
        const supDel = {
          userId: supp.userId,
          supplementId: supp.supplementId
        }
        addTransactionToDb('supplements', 'delete', supDel);
      })
    .catch((error)=>{
      console.log('deleteSupplementInDb', error);
      throw error;
    });
}

export async function getSupplementFromDb(lId, uId) {
    var sup = null;
    const ix = 'labelId, userId';
    const ids = [];
    ids.push(lId);
    ids.push(uId);
    //console.log('', ix, ids )
    getIndexedData('supplements', ix, ids)
      .then((result)=>{
        sup = result;
        return sup;
      })
      .catch((err)=>{
        console.log('getSupplementFromDb error', err);
        return null;
      });
}

export async function updateSupplementInDb(item) {
  item.dateUpdated = getNowISO();
  //console.log('updateSupplementInDb', item);
  updateData('supplements', item)
    .then ((result) => {
      //console.log('updateSupplement result', result);
      addTransactionToDb('supplements', 'update', item);
    })
    .catch((err) => {
      console.log('updateSupplement error', err);
    })
}

// transactions

export async function addTransactionToDb(dbName, action, data) {
  const registrationId = getCurrentUserRegistrationId();
  //console.log('addTransactionToDb', registrationId);
  if (!registrationId || registrationId === '') return;

  const newVals = {
    transactionId: getNowISO(),
    dateUpdated: getNowISO(),
    dbName: dbName,
    action: action,
    data: data,
    status: 'pending'
  }
  console.log('addTransactionToDb', newVals);
  // save transaction data
  if (!('serviceWorker' in navigator) || !('SyncManager' in window)) {
    console.log('Service Worker NOT ACTIVE, sync not registered');
    return;
  }

  console.log('serviceWorker active');
  const promise = navigator.serviceWorker.ready;

  var readyStatus = 'unknown';
  await Promise.race([promise, await Promise.resolve('xyz')]).then(function(value) {
    console.log('promiseState', value);
    if (value === 'xyz') {
      console.log('ready pending');
      readyStatus = 'pending';
    }else {
      console.log('ready resolved');
      readyStatus = 'resolved';
    }
  }, function(reason) {
    console.log('promise rejected', reason);
    readyStatus = 'rejected';
  });

  console.log('sw ready status', readyStatus);
  //if (readyStatus !== 'resolved') return;

  const sw = await promise;
  console.log('navigator.serviceWorker.ready', sw);

  insertValues('transactions', newVals)
    .then ((result) => {
      console.log('addTransactionToDb result', result);
      return sw.sync.register('sync-itiw');
    })
    .catch((err) => {
      console.log('addTransactionToDb error', err);
    });
}

export async function getTransactionsFromDb(db) {
  console.log('getTransactionsFromDb', db);
  try {
      const trans = await getAllData('transactions');
      console.log('getTransactionsFromDb result', trans);
      return trans;
  } catch(error) {
      console.log('getTransactionsFromDb error', error);
      return null;
  }
}

export async function deleteTransactionFromDb(id) {
  //console.log('deleteTransactionFromDb', id);
  let response = await deleteData('transactions', id)
  console.log('deleteTransactionFromDb response', response);
  return true;
}

export async function deleteAllTransactionsFromDb() {
  let response = await deleteAllData('transactions')
  await response;
  //console.log('deleteAllTransactionsFromDb done');
}

// prescriptions

export async function getPrescriptionsFromDb() {
  //console.log('getPrescriptionsFromDb');
  if (!prescriptionsState || prescriptionsState.loaded || prescriptionsState.loading) {
    //console.log('prescriptions already loaded or being loaded');
    return;
  }

  setPrescriptionsLoading(true);
  let prescriptionsUpdate = [];
  try {
    var pre = await getSelectedData(
      'prescriptions',
      'userId',
      getCurrentUserId()
    );
    //console.log('getAllData prescriptions', pre);
    pre.forEach((i) => {
      const data = i;
      prescriptionsUpdate.push(data);
    });
    updatePrescriptionsState({
      loaded: true,
      loading: false,
      prescriptions: prescriptionsUpdate,
    });
  } catch (err) {
    console.log('loadPrescriptions error', err);
  } finally {
    //console.log('loadPrescriptions done', prescriptionsUpdate);
  }
}

export async function addPrescriptionToDb(item) {
  //console.log('addPrescription', item);
  item.userId = getCurrentUserId();
  item.prescriptionId = generateUniqueId();
  item.dateUpdated = getNowISO();
  await insertValues('prescriptions', item)
    .then((result)=>{
      addTransactionToDb('prescriptions', 'add', item);
    })
  .catch((error)=>{
    console.log('addPrescriptionToDb', error);
    return false;
  });
  return true;
}

export async function deletePrescriptionInDb(pre) {
  //console.log('deletePrescriptionInDb', supp);
  if (!pre) return;
    deleteData('prescriptions', pre.prescriptionId)
      .then((result)=>{
        const preDel = {
          userId: pre.userId,
          prescriptionId: pre.prescriptionId
        }
        addTransactionToDb('prescriptions', 'delete', preDel);
      })
    .catch((error)=>{
      console.log('deletePrescriptionInDb', error);
      throw error;
    });
}

export async function getPrescriptionFromDb(lId, uId) {
    var sup = null;
    const ix = 'labelId, userId';
    const ids = [];
    ids.push(lId);
    ids.push(uId);
    //console.log('', ix, ids )
    getIndexedData('prescriptions', ix, ids)
      .then((result)=>{
        sup = result;
        return sup;
      })
      .catch((err)=>{
        console.log('getPrescriptionFromDb error', err);
        return null;
      });
}

export async function updatePrescriptionInDb(item) {
  item.dateUpdated = getNowISO();
  //console.log('updatePrescriptionInDb', item);
  updateData('prescriptions', item)
    .then ((result) => {
      //console.log('updatePrescription result', result);
      addTransactionToDb('prescriptions', 'update', item);
    })
    .catch((err) => {
      console.log('updatePrescription error', err);
    })
}
